module.exports = __webpack_public_path__ + "images/canonical-card/archived-icon.07222c7374edc19d8dd9.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/canonical-card/archived-icon.svg
// module id = jQZt
// module chunks = 2